//import React from 'react';
//import { useRedirect, useNotify } from 'react-admin';

//const queryString = require('query-string');

const cleanup = () => {
    // Remove the ?code&state from the URL
    window.history.replaceState(
        {},
        window.document.title,
        window.location.origin
    );
}

export default {
    login: (params = {}) => {
        if (!params.code || !params.state){
            console.log("!!do the start login redirect!!");
            const request = new Request('/login');
            localStorage.setItem('loggingin',true);
            return fetch(request)
                .then(function (response) {
                    if (response.status < 200 || response.status >= 300) {
                        localStorage.removeItem('loggingin');
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .then( function (payload) {
                    if (payload && payload.redirect) {
                        window.location = payload.redirect
                    }
                    return;
                });
        }
        else {
            console.log("!!check the code/state after redirect!!");
            const request = new Request('/userinfo?code=' + params.code +'&state=' + params.state );
            return fetch(request)
                .then(function (response) {
                    if (response.status < 200 || response.status >= 300) {
                        // window.location = '/';
                        // put a loged out thing up?
                        localStorage.removeItem('loggingin');
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .then( function (payload) {
                    console.log("!! login over !!" , payload);
                    localStorage.removeItem('loggingin');
                    cleanup(); // only try this once
                    if ( payload.token) {
                        console.log("trusted user",payload.user);
                        localStorage.setItem('token',payload.token);
                        //return Promise.resolve();
                    } else if ( payload.user) {
                        console.log("un-trusted user",payload.user);
                        console.log("error: ",payload.error);
                        return Promise.reject();
                    }
                    else {
                        console.log("failed to find user at all?");
                        console.log("error: ",payload.error);
                        return Promise.reject();
                    }
                    return;
                });

        }
    },
    logout: () => {
        console.log("!! logout !!");
        if ( localStorage.getItem('loggingin') ){
            console.log("!! ignore !!");
            return Promise.reject();
        }
        else {
            const request = new Request('/logout');
            localStorage.removeItem('token');
            localStorage.removeItem('loggingin');
            return fetch(request)
                .then(function (response) {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .then( function (payload) {
                    if (payload && payload.redirect) {
                        window.location = payload.redirect
                    }
                    return;
                })
                .catch(error => console.log("log out problem", error.message ));
        }
    },
    checkAuth: () => {
        console.log("!! check auth !!");
        if ( localStorage.getItem('token') ){
            console.log("!! ok !!");
            //TODO: check valid time etc?
            return Promise.resolve();
        }
        else {
            //if ( !localStorage.getItem('loggingin') ){
                console.log("!! ko !!");
            // return Promise.resolve();
                return Promise.reject();
            /* }
            else {
                // dont auto logout
                console.log("!! ?? !!");
                return Promise.resolve();
            } */
        }
    },
    checkError: error => {
        const status = error.networkError.statusCode;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getPermissions: params => Promise.resolve(),
};
